module.exports = __webpack_public_path__ + "img/tianjia@3x.a41e5004.svg";